<template>
  <div>
    <div class="row mb-3">
      <div class="col-12 col-md-6">
        <bs-card class="card-info">
          <apexchart type="radialBar" height="350" :options="chartOptions" :series="[speed]"></apexchart>
        </bs-card>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <bs-card class="card-info" style="height:430px">
          <mapbox :center="[this.vehicle.lng, this.vehicle.lat]" :icon="'dot'" />
        </bs-card>
      </div>
    </div>
    <bs-modal :name="'create-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: resource.id ? $t('labels.edit') : $t('labels.create') })">
      <bs-form :submit="$t('labels.submit')" @submit="submit">
        <template v-slot:default="slotProps">
          <tuxedo-input :name="'name'" :label="$t('labels.description')" :help="$t('tips.vehicle_description')" v-model="resource.name" :error="slotProps.error" />
          <tuxedo-input :name="'registration'" :label="$t('labels.registration')" :help="$t('tips.vehicle_registration')" v-model="resource.registration" :error="slotProps.error" />
          <tuxedo-input :name="'imei'" :label="$t('labels.imei')" v-model="resource.imei" :error="slotProps.error" />
        </template>
      </bs-form>
    </bs-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'VehicleDash',
  data () {
    return {
      loading: false,
      activeId: null,
      resource: {
        name: '',
        registration: '',
        imei: ''
      },
      vehicleTimer: null,
      chartOptions: {
        chart: {
          height: 350,
          type: 'radialBar',
          offsetY: -10
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            dataLabels: {
              name: {
                fontSize: '16px',
                color: undefined,
                offsetY: 120
              },
              value: {
                offsetY: 76,
                fontSize: '22px',
                color: undefined,
                formatter: function (val) {
                  return parseInt(val * 1.6) + ' km/h'
                }
              }
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            shadeIntensity: 0.15,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 65, 91]
          }
        },
        stroke: {
          dashArray: 4
        },
        labels: ['Current Speed']
      }
    }
  },
  mounted () {
    this.vehicleTimer = setInterval(this.show, 5000)
  },
  beforeDestroy () {
    clearInterval(this.vehicleTimer)
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      submitting: state => state.submitting,
      vehicle: state => state.vehicle.data
    }),
    speed () {
      const speed = this.vehicle ? this.vehicle.speed : 0
      return speed / 1.6
    }
  },
  methods: {
    show () {
      this.loading = true
      this.$store.dispatch('show', { object: 'Vehicle', id: this.vehicle.id }).then(() => {
        this.loading = false
      })
    },
    index () {
      this.$store.dispatch('index', {
        collection: this.$options.name
      }).then(() => {
        this.loading = false
      })
    },
    create () {
      this.$root.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
    },
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch(this.resource.id ? 'update' : 'store', { collection: this.$options.name, resource: this.resource }).then(() => {
        this.$modal.hide('create-' + this.$options.name)
      })
    },
    destruction () {
      this.$store.dispatch('destroy', { collection: this.$options.name, id: this.activeId }).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
      })
    }
  }
}
</script>
